import { Toast } from '../components/Toast.js';
import { seoService } from '../services/seoService.js';

export function renderAdminView() {
  seoService.update({
    title: 'Content Creator CMS & JSON Generator',
    description: 'Add new Sri Lankan movies, cast members, and soundtrack data to CinemaHala.'
  });

  const container = document.createElement('div');
  container.className = 'main-content';

  container.innerHTML = `
    <div class="section-header">
      <div>
        <h1 class="section-title">CinemaHala Content CMS</h1>
        <p style="color: var(--text-secondary); font-size: 0.88rem; margin-top: 2px;">
          Generate schema-validated JSON files for new movies and artists to sync with GitHub or Supabase.
        </p>
      </div>
    </div>

    <form id="admin-movie-form" style="background: var(--bg-surface); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg); padding: var(--space-lg); margin-bottom: var(--space-xl);">
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: var(--space-md); margin-bottom: var(--space-md);">
        <div>
          <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Movie Title (English)</label>
          <input type="text" id="form-title" required placeholder="e.g. Sinhabahu" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>
        <div>
          <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Sinhala Title (සිංහල)</label>
          <input type="text" id="form-sinhala-title" required placeholder="e.g. සිංහබාහු" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>
      </div>

      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: var(--space-md); margin-bottom: var(--space-md);">
        <div>
          <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Release Year</label>
          <input type="number" id="form-year" required value="2025" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>
        <div>
          <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Runtime (e.g. 125 min)</label>
          <input type="text" id="form-runtime" value="120 min" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>
        <div>
          <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Director Name</label>
          <input type="text" id="form-director" required placeholder="e.g. Prasanna Vithanage" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>
      </div>

      <div style="margin-bottom: var(--space-md);">
        <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Genres (comma separated)</label>
        <input type="text" id="form-genres" placeholder="Historical Drama, Thriller, Romance" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
      </div>

      <div style="margin-bottom: var(--space-md);">
        <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Poster Image URL</label>
        <input type="url" id="form-poster" placeholder="https://images.unsplash.com/..." style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
      </div>

      <div style="margin-bottom: var(--space-md);">
        <label style="display: block; font-size: 0.82rem; font-weight: 700; margin-bottom: 4px;">Synopsis / Plot Summary</label>
        <textarea id="form-synopsis" rows="3" placeholder="Enter movie story summary..." style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;"></textarea>
      </div>

      <div style="display: flex; gap: var(--space-sm); flex-wrap: wrap;">
        <button type="submit" class="btn-primary clickable-item">Generate JSON</button>
        <button type="button" id="copy-json-btn" class="btn-secondary clickable-item">Copy JSON</button>
        <button type="button" id="download-json-btn" class="btn-secondary clickable-item">Download File</button>
      </div>
    </form>

    <div id="output-preview-container" style="display: none; background: var(--bg-surface-elevated); border: 1px solid var(--border-gold); border-radius: var(--radius-md); padding: var(--space-md); margin-bottom: var(--space-xl);">
      <h3 style="font-size: 1rem; font-weight: 700; margin-bottom: 8px; color: var(--accent-gold);">Generated JSON Output</h3>
      <pre id="json-code-output" style="font-size: 0.82rem; color: #e2e8f0; overflow-x: auto; max-height: 350px; background: var(--bg-primary); padding: 12px; border-radius: var(--radius-sm);"></pre>
    </div>
  `;

  const form = container.querySelector('#admin-movie-form');
  const previewContainer = container.querySelector('#output-preview-container');
  const codeOutput = container.querySelector('#json-code-output');
  const copyBtn = container.querySelector('#copy-json-btn');
  const downloadBtn = container.querySelector('#download-json-btn');

  let currentGenerated = null;

  function generatePayload() {
    const title = container.querySelector('#form-title').value.trim();
    const sinhalaTitle = container.querySelector('#form-sinhala-title').value.trim();
    const year = parseInt(container.querySelector('#form-year').value, 10) || 2025;
    const runtime = container.querySelector('#form-runtime').value.trim() || '120 min';
    const directorName = container.querySelector('#form-director').value.trim();
    const genres = (container.querySelector('#form-genres').value || 'Drama')
      .split(',').map(s => s.trim()).filter(Boolean);
    const poster = container.querySelector('#form-poster').value.trim() || 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80';
    const synopsis = container.querySelector('#form-synopsis').value.trim() || 'Synopsis pending.';

    const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-') + `-${year}`;

    return {
      id: slug,
      title,
      sinhalaTitle,
      year,
      releaseDate: `${year}-01-01`,
      runtime,
      genres,
      rating: 5.0,
      ratingCount: 1,
      director: {
        id: directorName.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
        name: directorName,
        sinhalaName: ''
      },
      poster,
      backdrop: poster,
      synopsis,
      trailerUrl: '',
      cast: [],
      crew: [],
      songs: [],
      filmingLocations: [],
      whereToWatch: [],
      awards: [],
      trivia: [],
      quotes: [],
      interviews: []
    };
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    currentGenerated = generatePayload();
    codeOutput.textContent = JSON.stringify(currentGenerated, null, 2);
    previewContainer.style.display = 'block';
    previewContainer.scrollIntoView({ behavior: 'smooth' });
    Toast.show('JSON schema generated successfully!', 'success');
  });

  copyBtn.addEventListener('click', () => {
    if (!currentGenerated) currentGenerated = generatePayload();
    navigator.clipboard.writeText(JSON.stringify(currentGenerated, null, 2));
    Toast.show('JSON copied to clipboard!', 'success');
  });

  downloadBtn.addEventListener('click', () => {
    if (!currentGenerated) currentGenerated = generatePayload();
    const blob = new Blob([JSON.stringify(currentGenerated, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${currentGenerated.id}.json`;
    a.click();
    URL.revokeObjectURL(url);
    Toast.show(`Downloaded ${currentGenerated.id}.json!`, 'success');
  });

  return container;
}
